import DetectorInterface from "../DetectorInterface";
import Detector from '../Detector';

export default class Date extends Detector implements DetectorInterface {

    public match(value: string): boolean {

        if (typeof value !== 'string') return false;

        return /[0-9]{4}-[0-9]{2}-[0-9]{2}/igm.test(value.trim());
    }
}

